import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthErrorCodes, signOut } from 'firebase/auth';
import { auth } from '../firebase';

export default function Navbar() {
  const location = useLocation();

  const handleLogout = async () => {
    await signOut(auth);
  };

  const navItem = (path, label) => ({
    ...styles.navItem,
    ...(location.pathname === path ? styles.navItemActive : {}),
  });

  return (
    <div style={styles.navbar}>
      <a href="https://onshifts.ca" style={{ display: 'flex', alignItems: 'center' }}>
        <img src="/onshifts.png" alt="OnShifts" style={{ height: 44, width: 'auto', objectFit: 'contain' }} />
      </a>
      <div style={styles.navItems}>
        <Link to="/" style={navItem('/')}>Dashboard</Link>
        <Link to="/employees" style={navItem('/employees')}>Employees</Link>
        <Link to="/timesheets" style={navItem('/timesheets')}>Timesheets</Link>
        <Link to="/shifts" style={navItem('/shifts')}>Shifts</Link>
        <Link to="/schedule" style={navItem('/schedule')}>Schedule</Link>
        <Link to="/settings" style={navItem('/settings')}>Settings</Link>
      </div>
      <button style={styles.logoutButton} onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
}

const styles = {
  navbar: {
    backgroundColor: '#1e1e1e',
    padding: '0 32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 64,
    borderBottom: '1px solid #2a2a2a',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  brand: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 8,
  },
  brandText: {
    color: '#fff',
    fontSize: 22,
    fontWeight: 'bold',
  },
  brandSub: {
    color: '#4f46e5',
    fontSize: 13,
    fontWeight: 'bold',
  },
  navItems: {
    display: 'flex',
    gap: 8,
  },
  navItem: {
    color: '#999',
    textDecoration: 'none',
    padding: '8px 16px',
    borderRadius: 8,
    fontSize: 15,
    fontWeight: '500',
  },
  navItemActive: {
    color: '#fff',
    backgroundColor: '#2a2a2a',
  },
  logoutButton: {
    backgroundColor: 'transparent',
    color: '#999',
    border: '1px solid #333',
    borderRadius: 8,
    padding: '8px 16px',
    cursor: 'pointer',
    fontSize: 14,
  },
};